import { ButtonProps, Text } from "@chakra-ui/react";
import { NFTEventTier } from "@models/event";
import { formatPrice, usePaymentStore } from "../../payment";
import CheckoutBreadcrumb from "./CheckoutBreadCrumb";
import CheckoutButton from "./CheckoutButton";

const CheckoutToolbar = ({
  allowSubmit,
  checkoutButtonProps,
  tier,
}: {
  allowSubmit: boolean;
  checkoutButtonProps?: ButtonProps;
  tier?: NFTEventTier;
}) => {
  const transaction = usePaymentStore((state) => state.transaction);
  const t = (key?: string) => key || "";

  return (
    <>
      <div className="sm:hidden flex flex-col w-screen fixed left-0 bottom-0 dark:bg-neutral-900 bg-white z-10 border-t border-solid border-neutral-100 dark:border-neutral-600 p-4 m-auto shadow-xl justify-end">
        <div className="container flex flex-row items-baseline justify-between flex-wrap gap-4">
          <CheckoutBreadcrumb />
          {transaction && transaction.items.length > 0 && (
            <div className="flex flex-row justify-between w-full text-lg font-medium sm:hidden">
              <Text> {t("Total")} </Text>
              <div className="flex flex-col items-end">
                <Text>
                  {transaction.originalAmount
                    ? formatPrice(transaction.finalAmount, transaction.currency)
                    : t("Free")}
                </Text>

                {/* subscription */}
                <span className="text-xs">
                  {tier?.paymentConfig?.subscriptionInterval}
                </span>
              </div>
            </div>
          )}
          <CheckoutButton
            allowSubmit={allowSubmit}
            customButtonProps={checkoutButtonProps}
          />
        </div>
      </div>
    </>
  );
};

export default CheckoutToolbar;
